import { gtag } from './ganalytics.js'

const scriptURL = 'https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js';

let countryCodeAllocation = {
  // US Territories
  'MP': 'US', // Northern Mariana Islands
  'PR': 'US', // Puerto Rico
  'GU': 'US', // Guam
  'AS': 'US', // American Samoa
  'VI': 'US', // U.S. Virgin Islands
  
  // Independent countries in free association with the US
  'FM': 'US', // Federated States of Micronesia
  'MH': 'US', // Marshall Islands
  'PW': 'US', // Palau
  
  // Other territories or special cases
  'XK': 'AL', // Kosovo, special case, allocated to Albania
  'AC': 'SH', // Ascension Island, part of Saint Helena, Ascension and Tristan da Cunha
  'AN': 'NL', // Netherlands Antilles, dissolved, approximate allocation to the Netherlands
  'AQ': 'AQ', // Antarctica, governed by the Antarctic Treaty
  'TA': 'SH', // Tristan da Cunha, part of Saint Helena, Ascension and Tristan da Cunha
};

function allocateCountryCode(originalCode) {
  if (countryCodeAllocation.hasOwnProperty(originalCode)) {
    return countryCodeAllocation[originalCode];
  } else {
    // Return the original code if not found in the allocation object
    return originalCode;
  }
}

let countryCode = allocateCountryCode(document.querySelector("meta[name='epilogue:target-country']").content);

// Tor Network
if (countryCode == "T1") countryCode = "US";

let productComponent = document.getElementById("product-component-1671028250520");

let isInEu = (document.querySelector("meta[name='epilogue:in-eu']").content == "1");

let acceptedLocaleArray = document.querySelector("meta[name='epilogue:target-locale']").content.split(",", 1);
let acceptedLocale = "en-US";

let productPrice = document.querySelector("span[itemprop='price']").attributes.content.value;

if (acceptedLocale.length > 0) {
  acceptedLocale = acceptedLocaleArray[0];
}

function loadScript() {
  var script = document.createElement('script');
  script.async = true;
  script.src = scriptURL;
  (document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(script);
  script.onload = function() { ShopifyBuyInit(false) };
}

function ShopifyBuyInit(shouldFallback) {
  var client = ShopifyBuy.buildClient({
    domain: 'store.epilogue.co',
    storefrontAccessToken: 'eb1adc211d5f09607133ed9820bdadbd',
    language: acceptedLocale,
  });

  if (!shouldFallback) {
    var input = {buyerIdentity: {countryCode: countryCode.toUpperCase()}};
  } else { 
    console.warn("Using fallback initialization of Shopify Buy due to invalid country provided by Cloudflare.");
    var input = {buyerIdentity: {countryCode: "US"}};
  }

  var localStorageCheckoutKey = `${client.config.storefrontAccessToken}.${client.config.domain}.checkoutId`;

  let fn = null;
  if (localStorage.getItem(localStorageCheckoutKey) != null) {
    let checkout_id = localStorage.getItem(localStorageCheckoutKey);
    fn = client.checkout.fetch(checkout_id);
  } else {
    fn = client.checkout.create(input);
  };

  fn.then((checkout) => {
    if (checkout == null) {
      console.log("Checkout variable in promise is null!");
      console.log("Refreshing checkout cart, and forcing reload.");

      localStorage.removeItem(`${client.config.storefrontAccessToken}.${client.config.domain}.checkoutId`);
      ShopifyBuyInit();
      return 0;
    }

    localStorage.setItem(localStorageCheckoutKey, checkout.id)

    ShopifyBuy.UI.onReady(client).then((ui) => {
      var productEvents = {
        'beforeRender': (component) => {
          var legacyOrderButton = document.querySelector(".shopify__loading");

          if (legacyOrderButton != null) {
            var legacyParent = legacyOrderButton.parentNode;
            legacyParent.removeChild(legacyOrderButton);
          }
        },
        'addVariantToCart': (product) => {
          gtag('event', 'conversion', {
            'send_to': 'AW-11285628591/jLLoCKbxivoYEK-NtIUq',
            'value': productPrice,
            'currency': 'USD',
          });
        }
      };

      var cartEvents = {
        "openCheckout": (component) => {
          let total = component['model']['totalPrice'];

          gtag('event', 'conversion', {
            'send_to': 'AW-11285628591/5DemCOqRifoYEK-NtIUq',
            'value': total.amount,
            'currency': total.currencyCode,
          });
        },
      };

      let lineItemContents = {}
      if (isInEu) { lineItemContents = { "priceWithDiscounts": false } }

      ui.createComponent('product', {
        id: '6289999495359',
        node: productComponent,
        moneyFormat: '%24%7B%7Bamount%7D%7D',
        options: {
          "product": {
            "iframe": false,
            "events": productEvents,
            "styles": { "product": { "@media (min-width: 601px)": { "max-width": "calc(25% - 20px)", "margin-left": "20px", "margin-bottom": "50px" }, "text-align": "left" }, "button": { ":hover": { "background-color": "#691bcf" }, "background-color": "#2b0b55", "border-radius": 0, "font-family": "Open Sans,arial,sans-serif", ":focus": { "background-color": "#691bcf" } }
            },
            "contents": {
              "img": false,
              "title": false,
              "price": false
            },
            "text": { "button": "Order now" }
          },
          "lineItem": { "contents": lineItemContents, },
          "cart": {
            "events": cartEvents,
            "iframe": true,
            "styles": { "button": { ":hover": { "background-color": "#691bcf" }, "background-color": "#3e107a", ":focus": { "background-color": "#691bcf" } } },
            "text": { "total": "Subtotal", "button": "Checkout" },
            "popup": false,
            "contents": {
              "title": true,
              "lineItems": true,
              "footer": true,
            },
          },
          "toggle": {
            "styles": { "toggle": { "background-color": "#3e107a", ":hover": { "background-color": "#691bcf" }, ":focus": { "background-color": "#691bcf" } } }
          }
        }
      });
    });
  }).catch((error) => {
    console.warn("Error during Shopify Buy initialization:", error);
    console.warn("Attempting fallback initialization of ShopifyBuy");
    ShopifyBuyInit(true);
  });
};

if (window.ShopifyBuy) {
  if (window.ShopifyBuy.UI)
    ShopifyBuyInit(false);
  else 
    loadScript();
} else {
  loadScript();
}
